/** Traductions modal ajout fournisseur (FR / AR) */
export const addSupplierModalFr = {
  title: 'Ajouter Fournisseur',
  sectionInfo: 'Informations du Fournisseur',
  sectionIdentity: 'Identité',
  sectionContact: 'Coordonnées',
  sectionSettings: 'Paramètres',
  nameLabel: 'Nom',
  companyLabel: 'Entreprise',
  phoneLabel: 'Téléphone',
  addressLabel: 'Adresse',
  statusLabel: 'Statut',
  statusActive: 'Actif',
  statusInactive: 'Inactif',
  statusPending: 'En Attente',
  joinedDateLabel: 'Date d\'Adhésion',
  datePlaceholder: 'JJ/MM/AAAA',
  cancel: 'Annuler',
  submit: 'Ajouter Fournisseur',
  nameOrCompanyRequired: 'Veuillez saisir au moins un nom ou une entreprise.'
};

export const addSupplierModalAr = {
  title: 'إضافة مورد',
  sectionInfo: 'معلومات المورد',
  sectionIdentity: 'الهوية',
  sectionContact: 'بيانات الاتصال',
  sectionSettings: 'الإعدادات',
  nameLabel: 'الاسم',
  companyLabel: 'الشركة',
  phoneLabel: 'الهاتف',
  addressLabel: 'العنوان',
  statusLabel: 'الحالة',
  statusActive: 'نشط',
  statusInactive: 'غير نشط',
  statusPending: 'في الانتظار',
  joinedDateLabel: 'تاريخ الانضمام',
  datePlaceholder: 'يوم/شهر/سنة',
  cancel: 'إلغاء',
  submit: 'إضافة المورد',
  nameOrCompanyRequired: 'يرجى إدخال الاسم أو اسم الشركة على الأقل.'
};
